export class ContactProfiles {
  static VENDOR = 2;
  static LANDLORD = 4;
  static BUYER = 3;
  static TENANT = 5;
}
